import { useState, useEffect } from "react";
import api from "../../utils/api";

// Scans in the first 30/60/90 days after a product's first scan (launch = first scan, since codes are minted
// months ahead of retail launch). Independent of the date window.
const LaunchPerformanceGrid = ({ queryParams }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/api/analytics/launch-performance?${queryParams}`).then((r) => setRows(r.data)).catch(console.error).finally(() => setLoading(false));
  }, [queryParams]);

  if (loading) return <div className="text-center py-4"><div className="spinner-border spinner-border-sm" role="status" /></div>;
  if (rows.length === 0) return <p className="text-muted text-center mb-0">No products with codes.</p>;

  const num = (n) => n.toLocaleString();
  const cell = (r, key, days) => {
    if (!r.launchDate) return <td style={{ textAlign: "right", color: "#adb5bd" }}>—</td>;
    const incomplete = r.daysLive < days;
    return (
      <td style={{ textAlign: "right", color: incomplete ? "#adb5bd" : undefined }} title={incomplete ? `Only ${r.daysLive} days since first scan` : ""}>
        {num(r[key])}{incomplete ? "*" : ""}
      </td>
    );
  };

  return (
    <div>
      <p className="text-muted small mb-2">Scans within 30 / 60 / 90 days of each product's launch, where launch = the first scan recorded (codes are often created months ahead of retail). Not affected by the date window. * = window not yet complete. — = no scans yet.</p>
      <div style={{ maxHeight: "360px", overflow: "auto" }}>
        <table className="table table-sm table-hover" style={{ fontSize: "12px" }}>
          <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
            <tr><th>Item ID</th><th>Product</th><th>Codes created</th><th>First scan</th><th style={{ textAlign: "right" }}>30d</th><th style={{ textAlign: "right" }}>60d</th><th style={{ textAlign: "right" }}>90d</th><th style={{ textAlign: "right" }}>Lifetime</th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.productId}>
                <td style={{ fontFamily: "monospace", whiteSpace: "nowrap" }}>{r.itemId || "—"}</td>
                <td>{r.productName}</td>
                <td style={{ whiteSpace: "nowrap", color: "#6c757d" }}>{r.codesCreated}</td>
                <td style={{ whiteSpace: "nowrap" }}>{r.launchDate || <span className="text-muted">not yet</span>}</td>
                {cell(r, "d30", 30)}{cell(r, "d60", 60)}{cell(r, "d90", 90)}
                <td style={{ textAlign: "right", fontWeight: 600 }}>{num(r.total)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LaunchPerformanceGrid;
